import { SET_SELECTED_SEVEN_DAYS } from './types';


export const setSelectedSevenDays = payload => ({
  type: SET_SELECTED_SEVEN_DAYS,
  payload
});


